module.exports = __webpack_public_path__ + "img/reset-password-mobile-en.594d786c.jpg";